import { render, staticRenderFns } from "./Artwork.vue?vue&type=template&id=58fd3272&scoped=true&"
import script from "./Artwork.vue?vue&type=script&lang=js&"
export * from "./Artwork.vue?vue&type=script&lang=js&"
import style0 from "./Artwork.vue?vue&type=style&index=0&id=58fd3272&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fd3272",
  null
  
)

export default component.exports